import { Component, OnInit } from '@angular/core';
import { AuthservicesService } from '../../../services/authservices.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-staff-maneger',
  templateUrl: './staff-maneger.component.html',
  styleUrls: ['./staff-maneger.component.css']
})
export class StaffManegerComponent implements OnInit {
  arr = [1, 2, 3, 4, 5]
  loading = false
  staffArr = [];
  checkbox = []
  closeResult: string;
  modalOptions: NgbModalOptions;
  loadMoreArr = []
  totalItems
  showError
  loadingModel = false
  individualId
  staffType
  // Add Staff flow state
  staffTypeOptions: any[] = []
  selectedStaffType: string
  selectedIndividualId: string
  name: string
  // User selection list
  candidateUsers: any[] = []
  filteredUsers: any[] = []
  userSearchTerm: string = ''
  // Multi-select support
  selectedIndividualIds: string[] = []
  selectedUsers: any[] = []

  constructor(private authService: AuthservicesService, private router: Router, private modalService: NgbModal) {
  }


  ngOnInit() {
    this.staffList();
    this.staffUserType();
  }

  open(content, props) {
    this.individualId = props._id
    this.showError = false
    this.loadingModel = false
    this.addstaff(0)
    this.modalService.open(content, { scrollable: true, backdrop: 'static', keyboard: false }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  staffUserType(){
   this.authService.getStaffType().subscribe((res: any) => {
      console.log("value of resssssssssss@+:::::::::::",res)  
    // this.loading = true
      this.staffTypeOptions = Array.isArray(res?.items) ? res.items : []
 

      // res.items.forEach(e => {
      //   if (!e.staffType) {

      //   }
      //   else {
         
      //     this.staffArr.push(e)
      //   }
      // })

      // console.log(this.staffArr, 'arr')
    })
  }

  getUserForStaff(){
   this.authService.affilatedUserlist(0, 10,'user').subscribe((res: any) => {
      const items = Array.isArray(res?.items) ? res.items : (Array.isArray(res) ? res : [])
      this.candidateUsers = items
      this.filteredUsers = items
    })
  }

  
  
  staffList() {
    this.staffArr =[]
    this.authService.staffList(0, 10).subscribe((res: any) => {
      this.loading = true
 

      res.items.forEach(e => {
        if (!e.staffType) {

        }
        else {
         
          this.staffArr.push(e)
        }
      })

      console.log(this.staffArr, 'arr')
    },
      error => {
        console.log(error)
      })
  }


  addstaff(skip) {
    this.authService.addStaff(skip, 10).subscribe((res: any) => {
      this.loadingModel = true
      this.loadMoreArr = res.items
      this.totalItems = res.total
    }, error => {
      console.log(error)
    })
  }

  updateStaff() {
    let obj = {
      'individualId': this.individualId,
      'staffType': this.staffType,
      'name': this.name
    }
    this.authService.updateStaff(obj).subscribe((res: any) => {
      this.authService.successMessage(res.message, 'success').then((res)=>{
        if(res.value){
          this.loading = false
          this.staffList();

        }
      })
    },
      error => {
        this.authService.successMessage(error.error.message, 'error')
      })
  }



  deleteStaff(propsId, props) {
    let obj = {
      'id': propsId,
      'individualId': props._id,
    }
    let swall = this.authService.swal('delete')
    swall.then((result) => {
      if (result.value == true) {
        this.authService.deleteStaff(obj).subscribe((res: any) => {
          this.staffList();
          this.authService.successMessage(res.message, 'success')

        },
          error => {
            this.authService.successMessage(error.error.message, 'error')
          })
      }
    })
  }

  selectItem(e, props) {
    console.log(props)
    this.staffType = props._id
    this.updateStaff();
  }




  // Open Add Staff modal with preloaded lists
  openAddStaff(templateRef) {
    this.showError = false
    this.selectedStaffType = null
    this.selectedIndividualId = null
    this.selectedIndividualIds = []
    this.selectedUsers = []
    this.name = null
    this.individualId = null
    this.loadingModel = false
    // preload dropdown data
    this.staffUserType();
    this.getUserForStaff();
    this.addstaff(0);
    this.modalService.open(templateRef, { scrollable: true, backdrop: 'static', keyboard: false }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  // Open the user selector modal
  openUserSelector(templateRef) {
    // ensure list is loaded
    if (!this.candidateUsers?.length) {
      this.getUserForStaff();
    }
    this.userSearchTerm = ''
    this.filteredUsers = this.candidateUsers
    this.modalService.open(templateRef, { scrollable: true, backdrop: 'static', keyboard: false });
  }

  onUserSearchChange(event: any) {
    const q = (event?.target?.value || '').toLowerCase().trim()
    this.userSearchTerm = q
    if (!q) { this.filteredUsers = this.candidateUsers; return }
    this.filteredUsers = this.candidateUsers.filter(u => {
      const hay = `${u?.name || ''} ${u?.firstName || ''} ${u?.lastName || ''} ${u?.email || ''}`.toLowerCase()
      return hay.includes(q)
    })
  }

  // single-select via checkbox (radio-like behavior)
  toggleUserSelection(user: any) {
    const id = user?._id
    const idx = this.selectedIndividualIds.indexOf(id)
    if (idx >= 0) {
      this.selectedIndividualIds.splice(idx, 1)
      this.selectedUsers = this.selectedUsers.filter(u => u._id !== id)
    } else {
      this.selectedIndividualIds.push(id)
      this.selectedUsers = [...this.selectedUsers, user]
    }
    // keep backward-compatible single selection fields for any existing code paths
    this.selectedIndividualId = this.selectedIndividualIds[0] || null
    this.individualId = this.selectedIndividualId
    const names = this.selectedUsers.map(u => u?.name).filter(Boolean)
    this.name = names.length > 2 ? `${names[0]}, ${names[1]} +${names.length - 2}` : names.join(', ')
  }

  isUserSelected(id: string) {
    return this.selectedIndividualIds.includes(id)
  }

  onSelectStaffType(event: any) {
    this.selectedStaffType = event?.target?.value
  }

  onSelectIndividual(event: any) {
    const id = event?.target?.value
    const found = this.loadMoreArr?.find(x => x._id === id)
    this.selectedIndividualId = id
    this.individualId = id
    this.name = found?.name
  }

  submitAddStaff(modalRef?: any) {
    if ((this.selectedIndividualIds?.length || 0) === 0 || !this.selectedStaffType) {
      this.showError = true
      return
    }
    this.staffType = this.selectedStaffType
    // Batch submit one-by-one
    const toSubmit = [...this.selectedUsers]
    let remaining = toSubmit.length
    toSubmit.forEach(u => {
      this.individualId = u?._id
      this.name = u?.name
      const obj = {
        individualId: this.individualId,
        staffType: this.staffType,
        name: this.name
      }

      this.authService.addStaffList(obj).subscribe((res: any) => {
        remaining--
        if (remaining === 0) {
          this.loading = false
          this.staffList();
          if (modalRef) modalRef.close('Save click')
        }
      }, _err => {
        remaining--
        if (remaining === 0) {
          this.staffList();
          if (modalRef) modalRef.close('Save click')
        }
      })
    })
  }

}

